import React, {useState, useContext, useEffect} from 'react'
import Pie from './Pie'
import AppContext from '../../../contexts/app-context';
import AuthContext from '../../../contexts/auth-context';
import useAxios from '../../../hooks/useAxios';
import { urls } from '../../config/variables';

const TopDrugs = () => {
  const { globalFilterQuery } = useContext(AppContext);
  const { token } = useContext(AuthContext);
  const { operation } = useAxios();

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchData = () => {
    operation(
      {
        method: 'GET',
        url: urls.DRUGS_COUNT + (globalFilterQuery || ''),
        headers: { Authorization: `token ${token}` },
      },
      (data) => {
        setData(data);
        setLoading(false);
      },
      (err) => {
        setData([]);
        setLoading(false);
      }
    );
  }

  useEffect(() => {
    if (token) {
      fetchData();
    }
    // eslint-disable-next-line
  }, [globalFilterQuery, token])  

  // reformate data to fit pie chart component data format.
  const formattedData = data
  .filter(item => item.drug_count > 0)
  .map(item => ({
    label: item.drug_name,
    count: item.drug_count,
    cost: Number(item.drug_cost),
  }))
  .sort((a, b) => b.count - a.count);

  // Take top 10 to show in pie chart, the rest will be shown in details dialog.
  const top = formattedData.slice(0, 10);

  return (
    <Pie
      chartId='top-drug'
      data={formattedData}
      top={top}
      loading={loading}
      showLegend={false}
      showDetailsDialog={true}
      pieTitle="Top Drugs"
      pieCenterLabel="Drugs"
      dialogButtonLabel="More Details"
      dialogTitle="Top Drugs"
      tableHead={['Drug', 'Count', 'Cost', 'Share']} // Pass tableHead titles to DetailsDialog
    />
  )
}

export default TopDrugs